<template>
  <div class="card">
    <div class="card-header" id="headingAlert">
      <div class="d-flex align-items-center">
        <h5 class="mr-auto">General</h5>
        <button type="submit" form="edit-event-form" class="btn btn-hub-primary">
          Save
        </button>
        <button type="reset" form="edit-event-form" class="btn btn-secondary">
          Reset
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div :class="showCurrentExtensions ? 'col-6' : 'col-12'">
          <EditEventForm :event="event" />
        </div>
        <div class="col-6" v-if="showCurrentExtensions">
          <CurrentExtensions :default_type="event.event_type_id === 3 ? 'alert' : 'announcement'"></CurrentExtensions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CurrentExtensions from '../CurrentExtensions.vue'
import ValidationMixin from '../../mixins/ValidationMixin.vue'
import EditEventForm from './EditEventForm.vue'

export default {
  props: { 
    event: Object
  },
  components: { CurrentExtensions, EditEventForm },
  mixins: [ValidationMixin],
  data() {
    return {
      showCurrentExtensions: true
    }
  }
}
</script>

<style scoped>

</style>
